<template>
    <div
      class="global-notification"
      :class="{
        'success': styleNotification === 'success',
        'danger': styleNotification === 'error',
        'warning': styleNotification === 'warning',
      }"
    >
      {{message}}
    </div>
</template>

<script>
export default {
  name: 'notification',
  props: {
    message: {
      type: String,
      default: '',
    },
    styleNotification: {
      type: String,
      default: '',
    },
  },
  mounted() {
    setTimeout(() => {
      this.$Notification.close();
    }, 3000);
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .global-notification
    width: 300px
    min-height: 48px
    border-radius: 4px
    position: fixed
    top: 12px
    right: -312px
    z-index: 100
    display: flex
    align-items: center
    justify-content: center
    font-weight: 600
    opacity: .8
    transition: all .4s
    transition-delay: 2s
    &.success, &.danger, &.warning
      right: 12px
    &.success
      background-color: #68cd86
      border: 2px solid #689e78
      color: $white
    &.danger
      background-color: #e54d42
      border: 2px solid #824b47
      color: $white
    &.warning
      // background-color: $primary
      border: 2px solid $brand-twoo
      color: $grey-800
      @media (max-width: $widthTerciarySmall)
        margin: 0 auto
        left: 0
        right: 0
</style>
